import { useTranslation } from 'react-i18next';
import useAppModal from 'hooks/useAppModal';
import { PropertyExpectation } from 'models/PropertyExpectations';
import usePropertySettingsInitData from '../../../../usePropertySettingsInitData';
import PropertyExpectationAddEditModal from './PropertyExpectationAddEditModal';

const modalId = 'property-expectation-add-edit-modal';

const usePropertyExpectationAddEditModal = () => {
  const { openModal } = useAppModal();
  const { property } = usePropertySettingsInitData();
  const { t } = useTranslation();

  const openAddEditModal = (propertyExpectation?: PropertyExpectation) => {
    const params = {
      property,
      propertyExpectation,
    };

    openModal({
      customContent: (
        // @ts-expect-error TS2322 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
        <PropertyExpectationAddEditModal modalId={modalId} params={params} />
      ),
      id: modalId,
      title: t(
        `pageProperty.feesTaxesAndPolicies.propertyExpectations.modal.${
          propertyExpectation ? 'edit' : 'add'
        }Title`,
      ),
    });
  };

  const openAddPropertyExpectationModal = () => {
    openAddEditModal();
  };
  // @ts-expect-error TS7031 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
  const openEditPropertyExpectationModal = ({ propertyExpectation }) => {
    openAddEditModal(propertyExpectation);
  };

  return { openAddPropertyExpectationModal, openEditPropertyExpectationModal };
};

export default usePropertyExpectationAddEditModal;
